var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 7,
    stroke: "#BABABA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.158 15.2838C23.386 15.6033 23.5 15.7638 23.5 16C23.5 16.237 23.386 16.3967 23.158 16.7162C22.1335 18.1532 19.5168 21.25 16 21.25C12.4825 21.25 9.8665 18.1525 8.842 16.7162C8.614 16.3967 8.5 16.2362 8.5 16C8.5 15.763 8.614 15.6033 8.842 15.2838C9.8665 13.8468 12.4832 10.75 16 10.75C19.5175 10.75 22.1335 13.8475 23.158 15.2838Z",
    stroke: "#04245C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 16C18.25 15.4033 18.0129 14.831 17.591 14.409C17.169 13.9871 16.5967 13.75 16 13.75C15.4033 13.75 14.831 13.9871 14.409 14.409C13.9871 14.831 13.75 15.4033 13.75 16C13.75 16.5967 13.9871 17.169 14.409 17.591C14.831 18.0129 15.4033 18.25 16 18.25C16.5967 18.25 17.169 18.0129 17.591 17.591C18.0129 17.169 18.25 16.5967 18.25 16Z",
    stroke: "#2173FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.41d961d306ed7027be048baf7640f60d.svg";
export { ForwardRef as ReactComponent };